import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { Menu, MenuButton, MenuItem, useMenuProps } from '../../../../../components/DropdownSet';
import Tooltip from '../../../../../components/Tooltip';

const ExportActionsDropdown = ({
  selectedCount,
  disabled,
  isDownloading,
  onExportsUpdate,
  onExportsDownload,
  onExportsDelete,
}) => {
  const menuProps = useMenuProps({
    menuStyle: { width: 210 },
    className: 'export-actions-dropdown',
  });

  return (
    <Menu
      menuButton={
        <MenuButton variant="light" disabled={disabled}>
          Actions
        </MenuButton>
      }
      {...menuProps}
    >
      <Tooltip
        id="update-selected-tooltip"
        content={
          selectedCount
            ? 'Updates the end-date of the time period to the most recently available date and regenerates the export.'
            : null
        }
      >
        <MenuItem value="update" disabled={!selectedCount} onClick={onExportsUpdate}>
          <div className="text-nowrap d-flex align-items-center gap-12">
            <i className="hicon-reset text-16" />
            Update {selectedCount > 0 ? `${selectedCount} exports` : 'Exports'}
          </div>
        </MenuItem>
      </Tooltip>
      <MenuItem
        value="download"
        disabled={isDownloading || !selectedCount}
        onClick={onExportsDownload}
      >
        <div className="text-nowrap d-flex align-items-center gap-12">
          <i className="hicon-download-thin text-16" />
          Download {selectedCount > 0 ? `${selectedCount} exports` : 'Exports'}
        </div>
      </MenuItem>
      <MenuItem
        value="delete"
        className={cx(selectedCount ? 'text-rose' : '')}
        disabled={!selectedCount}
        onClick={onExportsDelete}
      >
        <div className="text-nowrap d-flex align-items-center gap-12">
          <i className="hicon-remove text-16" />
          Delete {selectedCount > 0 ? `${selectedCount} exports` : 'Exports'}
        </div>
      </MenuItem>
    </Menu>
  );
};

ExportActionsDropdown.propTypes = {
  selectedCount: T.number.isRequired,
  disabled: T.bool,
  isDownloading: T.bool,
  onExportsUpdate: T.func.isRequired,
  onExportsDownload: T.func.isRequired,
  onExportsDelete: T.func.isRequired,
};

export default ExportActionsDropdown;
